// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__x6F91","input":"Checkbox_input__7efbE"};